import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

/**
 * Error messages by keys
 */
export const ERROR_MESSAGES: any = {
  required: 't.cant-blank',
  required_true: 't.must-accepted',
  pattern: 't.invalid-format',
  password_pattern: 't.paswd-requirments',
  password_length: 't.length-symbols',
  must_match: 't.passwds-not-match',
  eighteen_years: 't.18-years-err',
  min: 't.amount-below-limit',
  max: 't.amount-above-limit',
  maxlength: 't.invalid-format',
  minlength: 't.invalid-format',
  ca_postal_code_error: 't.postal-code-error-for-ca',
  au_postal_code_error: 't.postal-code-error-for-au',
  yearInPast: 'error.year-in-past',
};

@Injectable({
  providedIn: 'root'
})
export class FormsErrorHandlerService {

  /**
   * Main key for message
   * @private
   */
  private _mainKeyForMessage: string;

  constructor() {
  }

  /**
   * Apply form errors with messages
   * And return object with errors for each key
   *
   * @param form
   * @param ssResponse
   * @param touch
   */
  public applyFormErrors(form: FormGroup, ssResponse: any = null, touch = false): any {

    const formErrors: any = {};

    ssResponse = ssResponse || {errors: {}};

    Object.keys(form.controls).forEach(controlKey => {
      const control: any = form.get(controlKey);

      let errors = {
        ...control.errors || {},
        ...(ssResponse.errors && ssResponse.errors[controlKey] || {})
      };

      const errorKeys = Object.keys(errors);

      if (errorKeys.length) {
        errorKeys.forEach(errorKey => {
          errors[errorKey] = this.getErrorMessageByKey(errorKey) || errors[errorKey];
        });
      } else {
        errors = null;
      }

      control.setErrors(errors);

      formErrors[controlKey] = this.errors(control);
      if (touch) {
        control.markAsTouched();
      }
    });

    /**
     * Uses for get errors which key not match control key
     */
    Object.keys(ssResponse).forEach(errorKey => {
      Object.keys(ssResponse[errorKey]).forEach(key => {
        if (!formErrors[key]) {
          formErrors[key] = Object.keys(ssResponse[errorKey][key]).map(error => ssResponse[errorKey][key][error]);
        }
      });
    });

    return formErrors;
  }

  /**
   * Returns array of error messages if exists for provided control
   *
   * @param control
   */
  public errors(control: AbstractControl | any): Array<string> {
    return Object.keys(control.errors || {}).map(key => {
      if (key === 't.min' || key === 't.max') {
        return `${key} ${control.errors[key][key]}`;
      } else {
        return this.getErrorMessageByKey(key) || control.errors[key];
      }
    });
  }

  /**
   * Returns error message for provided key
   *
   * @param key
   */
  public getErrorMessageByKey(key: string): string {
    return ERROR_MESSAGES[key] || '';
  }

  /**
   * Convert SS error response to array of errors
   *
   * @param error
   * @param includKeyInMessage
   */
  public ssBackendErrorsToArray(error: any, includKeyInMessage?: boolean): Array<string> {
    const errorList: any[] = [];

    if (error) {
      Object.entries(error).forEach(([key, value]) => {
        const type = typeof error[key];

        if (!Boolean(this._mainKeyForMessage) && key !== 'errors') {
          this._mainKeyForMessage = key;
        }

        if (type === 'object') {
          errorList.push(...this.ssBackendErrorsToArray(error[key], includKeyInMessage));
        } else if (type === 'string') {
          errorList.push(includKeyInMessage ? `${this._mainKeyForMessage[0]?.toUpperCase() + this._mainKeyForMessage.slice(1)}: ${value}` : error[key]);
        }
      });
    }

    return errorList;
  }
}
